import { byteArrToBase64Text, simpleDecode, uint8ArrayDecodeToBase64Text } from './aws-kms';

const AWS = require('aws-sdk/dist/aws-sdk-react-native');

// const dynamoDBConfig = {
//   region: AWS_CONFIG.REGION,
//   credentials: new AWS.CognitoIdentityCredentials(
//     {
//       IdentityPoolId: AWS_CONFIG.COGNITO_IDENTITY_POOL_ID,
//     },
//     { region: AWS_CONFIG.REGION },
//   ),
// };
// AWS.config.update({
//   dynamodb: dynamoDBConfig,
// });

const ddb = new AWS.DynamoDB();
const tableName = 'cytoscape';

// get encrypted data and decrypt:
export function getDBData(userId, callback) {
  // debug-console.log('getDBData : userId=' + userId);
  if (!userId) {
    alert('userId is null');
    return;
  }

  const params = {
    TableName: tableName,
    Key: {
      userId: { S: userId.toString() },
    },
    ProjectionExpression: 'config, zip', // 'tree, zip'
  };

  // Call DynamoDB to read the item from the table
  ddb.getItem(params, async (err, data) => {
    // $.unblockUI();
    // let userData = [];
    if (err) {
      console.error('Error loading data : \n' + JSON.stringify(err));
    } else {
      // debug-console.log('Load data Success for user: ' + userId);
      // if (data.Item && data.Item.tree) {
      // 	userData = data.Item.tree.S;
      if (data.Item && data.Item.zip) {
        const binaryData = data.Item.zip.B;

        // 1. User KMS to decrypt:
        // const latin1Text = await base64rawDecryptToUserData(userData);
        // 2. Use simple decode:

        const byteArr = simpleDecode(binaryData);
        const treeDataText = uint8ArrayDecodeToBase64Text(new Uint8Array(byteArr));

        // debug-console.log('getDBData: userData=' + treeDataText.length);
        callback({ data: treeDataText, config: data.Item.config?.S });
      } else {
        // debug-console.log('Loaded ZIP Data is empty for user : ', userId);
        getRawDBData(userId, callback);
      }
    }
  });
}

const getRawDBData = (userId, callback) => {
  // debug-console.log('getRawDBData : userId=' + userId);
  if (!userId) {
    alert('userId is null');
    return;
  }

  const params = {
    TableName: tableName,
    Key: {
      userId: { S: userId.toString() },
    },
    ProjectionExpression: 'tree', // 'tree, zip'
  };

  // Call DynamoDB to read the item from the table
  ddb.getItem(params, async (err, data) => {
    if (err) {
      console.error('getRawDBData: Error loading data : \n' + JSON.stringify(err));
    } else {
      // debug-console.log('getRawDBData: Load data Success for user: ' + userId);
      if (data.Item && data.Item.tree) {
        const userData = data.Item.tree.S;
        // debug-console.log('getRawDBData: userData=' + userData.length);
        callback(userData);
      } else {
        // debug-console.log('Loaded Data is empty for user : ', userId);
        callback('[]');
      }
    }
  });
};

export const saveDataEncrypted = async (config, encryptedByteArr, userId, callback) => {
  // debug-console.log(    'save DataEncrypted: 1. userId=' +      userId +      '. EncryptedByteArr=' +      encryptedByteArr.length +      ', config=',    config,  );
  if (!userId) return alert('userId is null');

  let base64Text;
  if (typeof encryptedByteArr === 'string') {
    base64Text = encryptedByteArr;
  } else if (typeof encryptedByteArr === 'object') {
    base64Text = byteArrToBase64Text(encryptedByteArr);
  } else {
    return alert('Not an array');
  }

  if (typeof config === 'object') {
    config = JSON.stringify(config);
  }
  // debug-console.log('save DataEncrypted: 2. encoded to base64Text(DB saving)=' + base64Text.length);
  // // debug-console.log(base64Text);

  // const testByteArray = textEncodeToByteArray(base64Text);
  // // debug-console.log('save DataEncrypted: 3. base64 -> encode to arr (to test sending), length='+testByteArray.length);

  const params = {
    TableName: tableName,
    Key: {
      userId: { S: userId.toString() },
    },
    UpdateExpression: 'SET zip = :val , config = :config , updatedAt = :now ',
    ExpressionAttributeValues: {
      ':val': { B: base64Text },
      ':config': { S: config },
      ':now': { N: Date.now().toString() },
    },
    ReturnValues: 'UPDATED_NEW',
  };

  // Call DynamoDB to add the item to the table

  const response = await ddb.updateItem(params, (err, data) => {
    if (err) {
      // debug-console.log('Error', err);
      alert('Error : ' + userId + ' : ' + JSON.stringify(err));
    } else {
      // debug-console.log(data);
      alert('Lưu dữ liệu thành công cho người dùng ' + userId);
    }
    callback(false); // turn off loader
  });
  // debug-console.log('save DataEncrypted: <-- 4. await UpdateDB response=');
  // debug-console.log(response);
  return response;
};

export const saveItem = async (tree, userId, callback) => {
  if (!userId) {
    alert('Empty user');
    return;
    // userId = $("#userId").text();
  }
  // debug-console.log('updateItem : userId=' + userId);
  if (!tree) {
    alert('Empty data');
    return;
    // tree = JSON.stringify(cy.elements().jsons());
  }
  if (typeof tree !== 'string') {
    tree = JSON.stringify(tree);
  }

  // used to test: const decrypted = encrypted.then(decrypt_KMS);
  const params = {
    TableName: tableName,
    Key: {
      userId: { S: userId.toString() },
    },
    UpdateExpression: 'SET tree = :val , updatedAt = :now ',
    ExpressionAttributeValues: {
      ':val': { S: tree },
      ':now': { N: Date.now().toString() },
    },
    ReturnValues: 'UPDATED_NEW',
  };

  // debug-console.log(params);
  // Call DynamoDB to add the item to the table
  ddb.updateItem(params, (err, data) => {
    if (err) {
      // debug-console.log('Error', err);
      alert('Error : ' + userId + ' : ' + JSON.stringify(err));
    } else {
      // debug-console.log(data);
      alert('Lưu dữ liệu thành công cho người dùng ' + userId);
    }
    callback(false); // turn off loader
    //   $.unblockUI();
  });
};

// function deleteItem() {
//   const params = {
//     TableName: tableName,
//     Key: {
//       userId: { S: 'VALUE' },
//     },
//   };

//   // Call DynamoDB to delete the item from the table
//   ddb.deleteItem(params, (err, data) => {
//     if (err) {
//       // debug-console.log('Error', err);
//     } else {
//       // debug-console.log('Success', data);
//     }
//   });
// }

// function putItem(data) {
//   if (!data) {
//     data = JSON.stringify(cy.elements().jsons());
//   }
//   // debug-console.log(data);
//   const params = {
//     TableName: tableName,
//     Item: {
//       userId: { S: userId },
//       updatedAt: { N: Date.now().toString() },
//       tree: { S: data },
//     },
//   };
//   // Call DynamoDB to add the item to the table
//   ddb.putItem(params, (err, data) => {
//     if (err) {
//       // debug-console.log('Error', err);
//     } else {
//       // debug-console.log('Success', data);
//     }
//   });
// }

// function query() {
//   /* This example queries items in the Music table. The table has a partition key and sort key (Artist and SongTitle), but this query only specifies the partition key value. It returns song titles by the artist named "No One You Know". */

//   const params = {
//     ExpressionAttributeValues: {
//       ':v1': {
//         S: '1',
//       },
//     },
//     KeyConditionExpression: 'userId = :v1',
//     IndexName: 'updatedAt',
//     //ScanIndexForward : false, // true = ASC
//     //Limit : '1',
//     ProjectionExpression: 'tree',
//     TableName: tableName,
//   };
//   ddb.query(params, (err, data) => {
//     if (err) // debug-console.log(err, err.stack);
//     else // debug-console.log(data);
//     // data = {
//     //  ConsumedCapacity: {
//     //  },
//     //  Count: 2,
//     //  Items: [
//     // 	{
//     //    "SongTitle": {
//     // 	 S: "Call Me Today"
//     // 	}
//     //   }
//     //  ],
//     //  ScannedCount: 2
//     // }
//   });
// }
